import { services } from "../client/src/data/services";
import { counties } from "../client/src/data/areas";

export const VALID_STATIC_PATHS: ReadonlySet<string> = new Set([
  "/",
  "/service-areas",
  "/gallery",
  "/contact",
  "/privacy-policy",
  "/robots.txt",
  "/sitemap.xml",
]);

export const VALID_SERVICE_SLUGS: ReadonlySet<string> = new Set(
  services.map((service) => service.slug),
);

export const VALID_COUNTY_SLUGS: ReadonlySet<string> = new Set(
  counties.map((county) => county.slug),
);

export const VALID_CITY_GROUP_SLUGS: ReadonlySet<string> = new Set(
  counties.flatMap((county) => county.groups.map((group) => group.slug)),
);

export function isKnownSpaPath(path: string): boolean {
  if (VALID_STATIC_PATHS.has(path)) return true;
  const serviceMatch = path.match(/^\/services\/([^\/]+)\/?$/);
  if (serviceMatch) return VALID_SERVICE_SLUGS.has(serviceMatch[1]);
  const countyMatch = path.match(/^\/service-areas\/([^\/]+)\/?$/);
  if (countyMatch) return VALID_COUNTY_SLUGS.has(countyMatch[1]);
  const groupMatch = path.match(/^\/([^\/]+)\/?$/);
  if (groupMatch) return VALID_CITY_GROUP_SLUGS.has(groupMatch[1]);
  return false;
}
